import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaTools,
  FaHandHoldingHeart,
  FaMoneyBillWave,
  FaClipboardList,
  FaCalendarAlt,
  FaChartBar,
  FaStickyNote,
  FaDatabase,
  FaCog,
  FaChevronDown,
  FaFemale,
  FaChild,
  FaFireAlt,
  FaBus,
  FaTractor,
  FaBriefcase,
  FaUserTie,
  FaImages,
  FaNewspaper,
  FaPhotoVideo,
  FaWhatsapp,
  FaSms,
  FaEnvelope,
  FaBell,
  FaReply,
  FaChartLine,
  FaRobot,
  FaPhoneAlt,
  FaUserFriends,
  FaCommentDots,
  FaAddressBook,
  FaFileAlt,
  FaHistory,
  FaPaperPlane,
} from "react-icons/fa";
import { MdAudiotrack } from "react-icons/md";
import { IoVideocam } from "react-icons/io5";
import { MdHowToVote } from "react-icons/md";
import { RiSpeakFill } from "react-icons/ri";
import { MdMeetingRoom } from "react-icons/md";

import profile from "../../essets/intpic1.png";

import "../../Styles/Sidebar.css";

function AdminSidebar() {
  const [isBeneficiariesOpen, setIsBeneficiariesOpen] = useState(false);
  const [isMultimediaOpen, setIsMultimediaOpen] = useState(false);
  const [isCommunicationOpen, setIsCommunicationOpen] = useState(false);
  const [isWhatsappOpen, setIsWhatsappOpen] = useState(false);
  const [isEmailOpen, setIsEmailOpen] = useState(false);

  const toggleBeneficiaries = () => {
    setIsBeneficiariesOpen((prev) => !prev);
  };

  const toggleMultimedia = () => {
    setIsMultimediaOpen((prev) => !prev);
  };

  const toggleCommunication = () => {
    setIsCommunicationOpen((prev) => !prev);
  };

  const toggleWhatsapp = () => {
    setIsWhatsappOpen((prev) => !prev);
  };

  const toggleEmail = () => {
    setIsEmailOpen((prev) => !prev);
  };

  return (
    <div className="sidebar">
      {/* <div className="sidebar-profile">
        <img src={profile} alt="profile" className="profile-img" />
        <h4>INR MLA</h4>
        <p>Welcome Back !</p>
      </div> */}

      {/* Menu */}
      <ul className="menu">
        <li>
          <NavLink to="/AdminDashboard/dashboard-home" className="menu-link">
            <FaTachometerAlt />
            <span>Dashboard</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/voters" className="menu-link">
            <FaUsers />
            <span>Voters</span>
          </NavLink>
        </li>

        {/* Development Works */}
        <li>
          <NavLink to="/AdminDashboard/development" className="menu-link">
            <FaTools />
            <span>Development Works</span>
          </NavLink>
        </li>

        {/* Beneficiaries with Dropdown */}
        <li>
          <div
            className="menu-link dropdown"
            onClick={toggleBeneficiaries}
          >
            <div className="left">
              <FaHandHoldingHeart />
              <span>Beneficiaries</span>
            </div>
            <FaChevronDown
              className={`dropdown-icon ${isBeneficiariesOpen ? "rotate" : ""}`}
            />
          </div>

          {isBeneficiariesOpen && (
            <ul className="submenu">
               <li>
                <NavLink to="/AdminDashboard/BeneficiaryLookup">
                  <FaMoneyBillWave className="submenu-icon" />
                  <span>BeneficiaryLookup</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/cmrf-table">
                  <FaMoneyBillWave className="submenu-icon" />
                  <span>CM Relief Fund</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/AdaBiddaNidhi">
                  <FaFemale className="submenu-icon" />
                  <span>Aadabidda Nidhi</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/ThallikiVandanamTable">
                  <FaChild className="submenu-icon" />
                  <span>Thalliki Vandanam</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/DeepamSchemeTable">
                  <FaFireAlt className="submenu-icon" />
                  <span>Deepam Scheme</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/MahaShakthiTable">
                  <FaBus className="submenu-icon" />
                  <span>Maha Shakthi (Free Bus Travel)</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/AnnadataSukhibhavaTable">
                  <FaTractor className="submenu-icon" />
                  <span>Annadata Sukhibhava</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/YuvagalamTable">
                  <FaBriefcase className="submenu-icon" />
                  <span>Yuvagalam</span>
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        {/* Multimedia with Dropdown (Gallery, MP3, Videos/MP4, Press) */}
        <li>
          <div className="menu-link dropdown" onClick={toggleMultimedia}>
            <div className="left">
              <FaPhotoVideo />
              <span>Multimedia</span>
            </div>
            <FaChevronDown
              className={`dropdown-icon ${isMultimediaOpen ? "rotate" : ""}`}
            />
          </div>

          {isMultimediaOpen && (
            <ul className="submenu">
              <li>
                <NavLink to="/AdminDashboard/AdminGalleryTable">
                  <FaImages className="submenu-icon" />
                  <span>Gallery</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/mp3-table">
                  <MdAudiotrack className="submenu-icon" />
                  <span>MP3</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/mp4-table">
                  <IoVideocam className="submenu-icon" />
                  <span>Videos (MP4)</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/AdminDashboard/AdminPressTable">
                  <FaNewspaper className="submenu-icon" />
                  <span>Press</span>
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        {/* ============ COMMUNICATION (MAIN DROPDOWN) ============ */}
        <li>
          <div className="menu-link dropdown" onClick={toggleCommunication}>
            <div className="left">
              <RiSpeakFill />
              <span>Communication</span>
            </div>
            <FaChevronDown
              className={`dropdown-icon ${isCommunicationOpen ? "rotate" : ""}`}
            />
          </div>

          {isCommunicationOpen && (
            <ul className="submenu">
              <li>
                <NavLink to="/AdminDashboard/AdminCommunicationDashboard">
                  <FaTachometerAlt className="submenu-icon" />
                  <span>Communication Dashboard</span>
                </NavLink>
              </li>

              {/* WhatsApp nested dropdown */}
              <li>
                <div className="submenu-dropdown" onClick={toggleWhatsapp}>
                  <div className="submenu-left">
                    <FaWhatsapp className="submenu-icon" />
                    <span>WhatsApp</span>
                  </div>
                  <FaChevronDown
                    className={`subdropdown-icon ${isWhatsappOpen ? "rotate" : ""}`}
                  />
                </div>

                {isWhatsappOpen && (
                  <ul className="subsubmenu">
                    <li>
                      <NavLink to="/AdminDashboard/whatsapp-send">
                        <FaPaperPlane className="subsubmenu-icon" />
                        <span>Send Message</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/AdminDashboard/whatsapp-broadcast">
                        <FaUserFriends className="subsubmenu-icon" />
                        <span>Broadcast List</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/AdminDashboard/whatsapp-templates">
                        <FaFileAlt className="subsubmenu-icon" />
                        <span>Templates</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/AdminDashboard/whatsapp-history">
                        <FaHistory className="subsubmenu-icon" />
                        <span>Chat History</span>
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>

              <li>
                <NavLink to="/AdminDashboard/sms-campaigns">
                  <FaSms className="submenu-icon" />
                  <span>SMS Campaigns</span>
                </NavLink>
              </li>

              {/* Email Campaigns nested dropdown */}
              <li>
                <div className="submenu-dropdown" onClick={toggleEmail}>
                  <div className="submenu-left">
                    <FaEnvelope className="submenu-icon" />
                    <span>Email Campaigns</span>
                  </div>
                  <FaChevronDown
                    className={`subdropdown-icon ${isEmailOpen ? "rotate" : ""}`}
                  />
                </div>

                {isEmailOpen && (
                  <ul className="subsubmenu">
                    <li>
                      <NavLink to="/AdminDashboard/email-compose">
                        <FaPaperPlane className="subsubmenu-icon" />
                        <span>Compose Email</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/AdminDashboard/email-templates">
                        <FaFileAlt className="subsubmenu-icon" />
                        <span>Email Templates</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/AdminDashboard/email-subscribers">
                        <FaAddressBook className="subsubmenu-icon" />
                        <span>Subscribers</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/AdminDashboard/email-history">
                        <FaHistory className="subsubmenu-icon" />
                        <span>Campaign History</span>
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>

              <li>
                <NavLink to="/AdminDashboard/push-notifications">
                  <FaBell className="submenu-icon" />
                  <span>Push Notifications</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/AdminDashboard/auto-replies">
                  <FaReply className="submenu-icon" />
                  <span>Auto Replies</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/AdminDashboard/campaign-analytics">
                  <FaChartLine className="submenu-icon" />
                  <span>Campaign Analytics</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/AdminDashboard/ai-calling-agent">
                  <FaRobot className="submenu-icon" />
                  <span>AI Calling Agent</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/AdminDashboard/calling-to-voters">
                  <FaPhoneAlt className="submenu-icon" />
                  <span>Calling to Voters</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/AdminDashboard/team-meeting">
                  <FaUserFriends className="submenu-icon" />
                  <span>Team Meeting</span>
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        <li>
          <NavLink to="/AdminDashboard/SurveyFeedbackTable" className="menu-link">
            <FaClipboardList />
            <span>Surveys & Feedback</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/EventsTable" className="menu-link">
            <FaCalendarAlt />
            <span>Events</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/ReportsPage" className="menu-link">
            <FaChartBar />
            <span>Reports</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/NotesFollowUpTable" className="menu-link">
            <FaStickyNote />
            <span>Notes & Follow Ups</span>
          </NavLink>
        </li>
         <li>
          <NavLink to="/AdminDashboard/AdminLocalLeadersTable" className="menu-link">
            <FaUserTie />
            <span>Loacal Leaders</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/JanataDarbarTable" className="menu-link">
            <FaDatabase />
            <span>Janata Darbar</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/AdminPollingBoothManagement" className="menu-link">
            <MdHowToVote />
            <span>Polling Day Management</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/AdminPoliticalSurveyWarRoom" className="menu-link">
            <MdMeetingRoom />
            <span>Political Survey War Room</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/AdminDashboard/SettingsPage" className="menu-link">
            <FaCog />
            <span>Settings</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default AdminSidebar;